<script setup lang="ts">
import { fetchStalls } from '~/lib/stall';

const name = "I Consilience Hall 2020 前"

definePageMeta({
  title: "模擬店 - I Consilience Hall 2020 前"
})

const { data: stalls } = useAsyncData(
  `stalls-${name}`,
  () => fetchStalls(name),
  { server: true, lazy: false }
)
</script>

<template>
  <article class="flex flex-col items-center max-w-[900px] mx-auto px-2 py-4">
    <Ribbon class="mb-4 text-md md:text-2xl">
      {{ name }}
    </Ribbon>

    <template v-if="stalls !== undefined">
      <div class="grid gap-4 grid-cols-1 md:grid-cols-2 mb-8">
        <template v-for="(stall, i) in stalls">
          <StallItem :data="stall" :index="i" />
        </template>
      </div>
    </template>

    <div class="mb-4">
      <NuxtLink class="btn btn-primary" to="/booth">
        前のページに戻る
      </NuxtLink>
    </div>
  </article>
</template>